export const getIsDisabledChangeButton = (chosenType, activeType) => {
  return !chosenType || chosenType === activeType;
}